import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface FixedPriceProjectFilters {
  customerId?: number | null;
  projectId?: number | null;
  includeCompleted: boolean;
}

export interface FixedPriceProject {
  customername: string;
  project_id: number;
  project_name: string;
  extprojectid: string | null;
  start_date: string | null;
  stop_date: string | null;
  budget_hours: number | null;
  budget_money: number | null;
  used_hours: number;
  used_money: number;
  invoiced_hours: number;
  invoiced_money: number;
  remaining_hours: number | null;
  remaining_money: number | null;
  used_percent: number | null;
  is_completed: boolean;
}

export interface FixedPriceProjectTimerecord {
  reporteddate: string;
  name: string;
  activity_name: string;
  price: number;
  hours: number;
  amount: number;
  invoiced: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FixedPriceProjectsService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  getProjects(filters: FixedPriceProjectFilters): Observable<FixedPriceProject[]> {
    let params = new HttpParams().set('include_completed', String(filters.includeCompleted));

    if (filters.customerId !== null && filters.customerId !== undefined) {
      params = params.set('customer_id', String(filters.customerId));
    }
    if (filters.projectId !== null && filters.projectId !== undefined) {
      params = params.set('project_id', String(filters.projectId));
    }

    return this.http.get<FixedPriceProject[]>('/api/fixedpriceprojects', { params });
  }

  getTimerecords(projectId: number): Observable<FixedPriceProjectTimerecord[]> {
    return this.http.get<FixedPriceProjectTimerecord[]>(
      `/api/fixedpriceprojects/${projectId}/timerecords`
    );
  }
}
